
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_1xk9g_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_1xk9g_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_1xk9g_119",
  "icon": "awsui_icon_gwq0h_1xk9g_133",
  "root": "awsui_root_gwq0h_1xk9g_151",
  "expand-button": "awsui_expand-button_gwq0h_1xk9g_167",
  "expanded": "awsui_expanded_gwq0h_1xk9g_174",
  "icon-container": "awsui_icon-container_gwq0h_1xk9g_178",
  "icon-container-container": "awsui_icon-container-container_gwq0h_1xk9g_183",
  "wrapper": "awsui_wrapper_gwq0h_1xk9g_187",
  "wrapper-default": "awsui_wrapper-default_gwq0h_1xk9g_194",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_1xk9g_194",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_1xk9g_197",
  "wrapper-container": "awsui_wrapper-container_gwq0h_1xk9g_200",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_1xk9g_204",
  "header-deprecated": "awsui_header-deprecated_gwq0h_1xk9g_218",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_1xk9g_242",
  "header": "awsui_header_gwq0h_1xk9g_218",
  "header-wrapper": "awsui_header-wrapper_gwq0h_1xk9g_261",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_1xk9g_271",
  "header-button": "awsui_header-button_gwq0h_1xk9g_276",
  "header-container-button": "awsui_header-container-button_gwq0h_1xk9g_276",
  "header-container": "awsui_header-container_gwq0h_1xk9g_276",
  "header-navigation": "awsui_header-navigation_gwq0h_1xk9g_308",
  "header-text": "awsui_header-text_gwq0h_1xk9g_340",
  "content": "awsui_content_gwq0h_1xk9g_97",
  "content-default": "awsui_content-default_gwq0h_1xk9g_347",
  "content-footer": "awsui_content-footer_gwq0h_1xk9g_350",
  "content-expanded": "awsui_content-expanded_gwq0h_1xk9g_353",
  "content-compact": "awsui_content-compact_gwq0h_1xk9g_356",
  "focusable": "awsui_focusable_gwq0h_1xk9g_360",
  "click-target": "awsui_click-target_gwq0h_1xk9g_371"
};
  